<template>
  <div class="nav-wrap">
    <div class="header-navigation">
      <div class="navigation-dropdown-wrapper">
        <router-link :to="{ name: 'admin-companies-list' }" active-class="active">
          <span>{{ $tr('admin_console.navigation.companies') }}</span>
        </router-link>

        <div v-if="loaded" ref="navigation_dropdown" class="navigation-dropdown">
          <div
            class="navigation-dropdown-link"
            :class="{ 'navigation-dropdown-link__active': is_companies_dropdown_visible }"
            @click="toggleCompaniesDropdown"
          ></div>

          <ul v-if="is_companies_dropdown_visible" class="navigation-dropdown-list">
            <li v-if="isDomainRu">
              <a
                href="#"
                class="navigation-dropdown-item navigation-dropdown-item__invite"
                @click.prevent="handleInviteCompany"
              >
                <span>{{ $tr('admin_console.navigation.inviteCompany') }}</span>
              </a>
            </li>

            <li v-if="isDomainRu">
              <a
                href="#"
                class="navigation-dropdown-item navigation-dropdown-item__order"
                @click.prevent="go_to_companies_requests"
              >
                <span>{{ $tr('admin_console.navigation.newRequests') }}</span>
              </a>
            </li>

            <li v-if="isDomainRu">
              <a
                href="#"
                class="navigation-dropdown-item navigation-dropdown-item__order"
                @click.prevent="go_to_companies_moderation"
              >
                <span>{{ $tr('admin_console.navigation.moderation') }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <router-link :to="{ name: 'admin-settings' }" active-class="active">
        <span>{{ $tr('admin_console.navigation.settings') }}</span>
      </router-link>

      <router-link :to="{ name: 'admin-responses' }" active-class="active">
        <span>{{ $tr('admin_console.navigation.responses') }}</span>
      </router-link>
    </div>

    <invite-modal
      v-if="isInviteModalVisible"
      :is-success="isInviteModalSuccess"
      @submit="inviteCompany"
      @close="toggleInviteModalVisible(false)"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { isDomainRu } from '@/_helpers/utils.js';
import InviteModal from '@/routes_new/inner/admin/components/InviteModal';

export default {
  name: 'AdminHeaderNavigation',

  components: {
    InviteModal
  },

  data() {
    return {
      is_companies_dropdown_visible: false,
      isInviteModalVisible: false,
      isInviteModalSuccess: false,
      domain: '',
      loaded: false
    };
  },

  computed: {
    currentUser() {
      return this.$store.getters['user/current'] || {};
    }
  },

  beforeMount() {
    const host = window.location.hostname;
    const hostArray = host.split('.');
    this.domain = `${hostArray.slice(hostArray.length - 1)}`;

    if (this.domain) {
      this.loaded = true;
    }
  },

  mounted() {
    document.body.addEventListener('click', this.hide);
  },

  destroyed() {
    document.body.removeEventListener('click', this.hide);
  },

  methods: {
    toggleCompaniesDropdown() {
      this.is_companies_dropdown_visible = !this.is_companies_dropdown_visible;
    },

    toggleInviteModalVisible(val) {
      this.isInviteModalVisible = val;

      if (!val) {
        this.isInviteModalSuccess = false;
      }
    },

    isDomainRu() {
      return isDomainRu();
    },

    go_to_companies_requests() {
      this.is_companies_dropdown_visible = false;
      this.$router.push({
        name: 'admin-companies-requests'
      });
    },

    go_to_companies_moderation() {
      this.is_companies_dropdown_visible = false;
      this.$router.push({
        name: 'admin-companies-moderation'
      });
    },

    handleInviteCompany() {
      this.toggleInviteModalVisible(true);
    },

    inviteCompany({ email, language }) {
      const userId = this.currentUser ? this.currentUser.id : null;

      if (!userId) {
        return;
      }

      axios
        .post('v2/registration/invites', {
          email,
          user_id: userId,
          language_code: language.code,
          type: 'create_new_company'
        })
        .then(() => {
          // this.$noty.success('Приглашение успешно отправлено');
          // this.toggleInviteModalVisible(false);
          this.isInviteModalSuccess = true;
        })
        .catch(e => {
          let message = '';
          if (e && e.response && e.response.data && e.response.data.email) {
            message = this.$tr(`error.${Object.keys(e.response.data.email)[0]}`);
          } else {
            message = this.$tr('common.error');
          }
          this.$noty.error(message);
        });
    },

    hide(e) {
      if (!this.$refs.navigation_dropdown) {
        return;
      }
      if (!this.$refs.navigation_dropdown.contains(e.target)) {
        this.is_companies_dropdown_visible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/variables.scss';
@import '@/styles/fonts.scss';

.header-navigation {
  display: flex;
  align-self: center;
  justify-content: flex-start;
  list-style: none;
  padding: 0;
  margin: auto;
  margin-left: 60px;
  font-size: 16px;

  a {
    display: block;
    margin-right: 20px;
    text-align: center;

    span {
      @include mixin-text-header;
      border-bottom: 3px solid $white-color;
      padding: 23px 2px 0 2px;
      height: 64px;
      display: block;
      box-sizing: border-box;
      color: $main-dark;

      &:hover {
        color: $green-hover;
        transition: color 0.3s;
      }

      &.active {
        color: $green-active;
        transition: color 0.3s;
      }
    }

    &.active {
      span {
        border-bottom-color: $green;
      }
    }
  }
}

.main-nav ul li:not(:last-child) {
  margin-right: 20px;
}

@media (max-width: 1000px) {
  .main-nav {
    display: none;
  }
}

.navigation-dropdown-wrapper {
  display: flex;
  align-items: center;
  margin-right: 20px;
  position: relative;

  a {
    margin-right: 0;
  }
}

.navigation-dropdown {
  margin-left: 5px;
}

.navigation-dropdown-link {
  background: url(/static/images/elements/drop-arrow-reg-select.svg) center calc(50% + 2px)
    no-repeat;
  width: 11px;
  height: 50px;
  cursor: pointer;
}

.navigation-dropdown-link__active {
  transform: rotate(-180deg);
  background-position: center calc(50% - 2px);
}

.navigation-dropdown-list {
  margin: 0;
  padding: 0;
  background: #fff;
  border: 1px solid #d2d6e0;
  box-sizing: border-box;
  border-radius: 2px;
  position: absolute;
  left: 0;
  top: 65px;
  list-style: none;
}

.header-navigation a.navigation-dropdown-item {
  padding: 10px 20px 10px 35px;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.005em;
  color: #233346;
  text-align: left;
  white-space: nowrap;

  &:hover {
    background-color: #f4f5f7;
    color: #233346;
  }

  span {
    border: 0;
    padding: 0;
    height: auto;
    white-space: nowrap;
    color: #233346;

    &:hover {
      color: #233346;
    }
  }
}

.navigation-dropdown-item__order {
  background: url(/static/images/elements/icon_new_request.svg) 16px center no-repeat;
}

.navigation-dropdown-item__invite {
  background: url(/static/images/elements/icon_invite.svg) 16px center no-repeat;
}

.nav-wrap {
  margin-right: auto;
}
</style>
